/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: search.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  11.11.22 2:30 pm.
 * Last modified: 11.11.22 2:30 pm.
 *
 * More information at: https://egt-digital.com/
 */
import eventStore from '../eventStore';
import IGameSettings from '../interfaces/IGameSettings';
import { copyGameSetting } from './helpers';

const extractGames = (): IGameSettings[] => {
    const result: IGameSettings[] = [];
    const extractedGameKeys: string[] = [];

    eventStore.SETTINGS.value.sections.forEach(section => {
        section.games.forEach(game => {
            if (!extractedGameKeys.includes(game.gameKey)) {
                extractedGameKeys.push(game.gameKey);
                const newGame = {
                    ...copyGameSetting(game),
                    banners: {
                        lobby: { rows: 1, cols: 1 },
                        section: { rows: 1, cols: 1 },
                    },
                };
                result.push(newGame);
            }
        });
    });

    return result;
};

const getUniqueValues = (values: string[]): string[] =>
    values.reduce<string[]>((prev, curr) => {
        if (prev.indexOf(curr) === -1) {
            prev.push(curr);
        }
        return prev;
    }, []);

export const setSearchBy = (str: string) => {
    const allGames: IGameSettings[] = extractGames();
    const words = str.trim().split(' ');
    const searchValues = getUniqueValues(words);

    const foundGames: IGameSettings[] = [];
    const foundGameKeys: string[] = [];

    if (str.length) {
        allGames.forEach(game => {
            const nameIncludes = doesNameIncludes(game.name, searchValues);
            const nameIncludesAll = doesNameIncludesAll(game.name, words);

            if (!foundGameKeys.includes(game.gameKey) && nameIncludes) {
                if (words.length === 1) {
                    foundGameKeys.push(game.gameKey);
                    foundGames.push(game);
                } else if (words.length > 1 && nameIncludesAll) {
                    foundGameKeys.push(game.gameKey);
                    foundGames.push(game);
                }
            }
        });
    }

    eventStore.SEARCH.next({
        ...eventStore.SEARCH.value,
        games: foundGames,
        gridBlocks: foundGames.length,
        inputValue: str,
        searchingValues: searchValues,
    });
};

const doesNameIncludes = (name: string, values: string[]): boolean =>
    values.map(value => name.toUpperCase().indexOf(value.toUpperCase()) !== -1).includes(true);

const doesNameIncludesAll = (name: string, values: string[]): boolean =>
    !values.map(value => name.toUpperCase().indexOf(value.toUpperCase()) !== -1).includes(false);
